import { DialogButton } from '@ui/uikit/components/common/Dialog';

import type { PredictionButtonProps } from './ButtonProps';

export const LockedPredictionButton = ({ participation }: PredictionButtonProps) => (
  <DialogButton variant="secondary" isDisabled>
    {participation.isParticipated && <>You bet on {participation.direction} • </>}
    Price locked
  </DialogButton>
);
